import { put, takeLatest } from "@redux-saga/core/effects";
import { PayloadAction } from "@reduxjs/toolkit";
import { call } from "redux-saga/effects";
import fetchAPI, { ApiResponse, Pagination } from "../../../utils/api";
import activityPageSlice from "./slice";

type ActivityResponse = ApiResponse<{ data: boolean; meta: Pagination }>;

function* activityPageSaga() {
  yield takeLatest(activityPageSlice.actions.request, handleRequest);
}

function* handleRequest({ payload: page }: PayloadAction<number>) {
  const response: ActivityResponse = yield call(
    fetchAPI,
    `/activity?page=${page}`
  );

  if (response && response.data && response.meta) {
    yield put(activityPageSlice.actions.setData(response));
  }

  yield put(activityPageSlice.actions.setIsLoading(false));
}

export default activityPageSaga;
